import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { Authguard } from './helper';
import { LoginLayoutComponent, HomeComponent, P401Component, P403Component, P404Component } from './views';


export const routes: Routes = [
    { path: '', redirectTo: 'login', pathMatch: 'full'},
    {
      path: '',
      component: LoginLayoutComponent,
      data: {
        title: 'Login'
      },
      children: [
        {
          path: '', loadChildren: './views/login-layout/login-layout.module#LoginLayoutModule'
        }
      ]
    },
    { path: '401', component: P401Component },
    { path: '403', component: P403Component },
    { path: '404', component: P404Component },
    {
      path: 'home',
      component: HomeComponent,
      canActivate: [ Authguard ],
      data: {
        title: 'Home'
      },
      children: [
        {
          path: '',
          loadChildren: './views/home/home.module#HomeModule'
        }
      ]
    },
    { path: '**', redirectTo: '/404' }
];

@NgModule({
    imports: [ RouterModule.forRoot(routes) ],
    exports: [ RouterModule ]
})

export class AppRoutingModule {
}



// WEBPACK FOOTER //
// /Users/adminuser/Documents/pentagon/pentagon-admin/src/app/app-routing.module.ts